export const normalizeBetId = (value) => /^\d{1,3}(?:,\d{3})+$/.test(value) ? value.replace(/,/g, '') : value;
export const isBetId = (value) => /^(?:\d{1,15}|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i.test(normalizeBetId(value));

// Parse text, never HTML. Invalid IDs are still actionable so the receipt dialog
// can explain the problem, while surrounding punctuation/text stays untouched.
export const splitBetCommands = (message) => {
  const parts = [];
  const pattern = /\/bet(?:\s+|\/)(\d{1,3}(?:,\d{3})+(?![\w,-])|[^\s<>"'\[\](){},!?;:]+)/gi;
  let cursor = 0;
  for (const match of message.matchAll(pattern)) {
    if (match.index > 0 && !/[\s([{]/.test(message[match.index - 1])) continue;
    const betId = match[1].replace(/\.+$/, '');
    if (!betId) continue;
    const end = match.index + match[0].length - (match[1].length - betId.length);
    if (match.index > cursor) parts.push({ text: message.slice(cursor, match.index) });
    parts.push({ text: message.slice(match.index, end), betId });
    cursor = end;
  }
  if (cursor < message.length) parts.push({ text: message.slice(cursor) });
  return parts;
};